import { combineReducers } from "redux";
import test from "./test";
import channel from "./channel";

const rootReducer = combineReducers({
  test: test,
  channel: channel,
});

export default rootReducer;
